import { Close } from "@mui/icons-material";
import { Button, Drawer } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import InputField from "components/Input/InputField";
import TextArea from "components/Input/TextArea";
import UploadFile from "components/Input/UploadFile";
import axios from "const/axios";
import { useEffect, useLayoutEffect, useState } from "react";
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
import { hasPermission } from "utils/permissionUtils";
import { P } from "const/permissions";

export default function AddPriceDrawer({
  open,
  handleClose,
  refetchPriceList,
  setOpenAddPriceDrawer,
  viewOnly = !hasPermission(P.PRICELIST.CREATE),
}) {
  const initialState = {
    module: "",
    minimumServiceCharge: "",
    maximumServiceCharge: "",
    normalServiceCharge: "",
    governmentFees: "",
    requirements: "",
    checklist: "",
    notes: "",
    key1: "",
    key2: "",
    key3: "",
    key4: [],
    key5: [],
  };

  const [data, setData] = useState(open?.data || initialState);
  useLayoutEffect(() => {
    if (open?.id && open?.data) {
      // Merge the existing data with initial state to ensure all fields exist
      setData({ ...open?.data, key4: open?.data?.key4?.filter((item) => item !== "") });
    } else {
      setData(initialState);
    }
  }, [open?.id, open?.data]);

  const toggleDrawer = (event) => {
    handleClose();
    // setData(initialState);
  };

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleAddMore = () => {
    addPriceList({ data, addMore: true });
  };

  const { mutate: addPriceList, isLoading } = useMutation({
    mutationFn: ({ data }) => {
      if (data?.id) {
        return axios.put(`pricelists/${open?.id}`, data);
      } else {
        return axios.post(`pricelists`, data);
      }
    },
    onSuccess: (response, variables) => {
      toast.success(open?.id ? "Price List updated successfully" : "Price List added successfully");
      if (variables?.addMore) {
        setData(initialState);
      } else {
        handleClose();
      }
      refetchPriceList();
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Error saving price list");
    },
  });

  const handleSave = (type) => {
    addPriceList({ data, addMore: false });
  };

  return (
    <Drawer
      anchor={"right"}
      open={open?.state}
      onClose={handleClose}
      PaperProps={{ style: { width: "35%" } }}
    >
      <div className="flex justify-between p-4 border-b">
        <h1 className="text-xl font-semibold">{open?.id ? "Edit Price List" : "Add Price List"}</h1>
        <Close onClick={toggleDrawer} className="cursor-pointer" />
      </div>
      <div className="p-4 flex flex-col gap-4 overflow-y-auto mb-20">
        <div className="relative w-full mb-3">
          <InputField
            label="Module"
            name="module"
            value={data?.module}
            required
            onChange={handleInputChange}
            disabled={viewOnly}
          />
        </div>
        <div className="relative w-full mb-3">
          <InputField
            label="Minimum Service Charge"
            name="minimumServiceCharge"
            value={data?.minimumServiceCharge}
            required
            onChange={handleInputChange}
            disabled={viewOnly}
          />
        </div>
        <div className="relative w-full mb-3">
          <InputField
            label="Maximum Service Charge"
            name="maximumServiceCharge"
            value={data?.maximumServiceCharge}
            required
            onChange={handleInputChange}
            disabled={viewOnly}
          />
        </div>
        <div className="relative w-full mb-3">
          <InputField
            label="Normal Service Charge"
            name="normalServiceCharge"
            value={data?.normalServiceCharge}
            required
            onChange={handleInputChange}
            disabled={viewOnly}
          />
        </div>
        <div className="relative w-full mb-3">
          <InputField
            label="Government Fees"
            name="governmentFees"
            value={data?.governmentFees}
            required
            onChange={handleInputChange}
            disabled={viewOnly}
          />
        </div>
        <div className="relative w-full mb-3">
          <label className="block uppercase text-app-text-secondary text-xs font-semibold mb-2">
            Checklist
          </label>
          <ReactQuill
            label="Checklist"
            name="requirements"
            value={data?.requirements}
            onChange={(value) => handleInputChange({ target: { name: "requirements", value } })}
            disabled={viewOnly}
          />
        </div>
        {/* <div className="relative w-full mb-3">
          <TextArea
            label="Checklist"
            name="checklist"
            value={data?.checklist}
            onChange={handleInputChange}
          />
        </div> */}
        <div className="relative w-full mb-3">
          <TextArea
            label="Notes"
            name="notes"
            value={data?.notes}
            onChange={handleInputChange}
            disabled={viewOnly}
          />
        </div>
        <div className="relative w-full mb-3">
          <UploadFile
            label="Attachments"
            imageKey="key4"
            data={data}
            setData={setData}
            type="multiple"
          />
        </div>
      </div>
      {hasPermission(P.PRICELIST.CREATE) && (
        <div className="p-4 absolute bottom-0 w-full border-t">
          <div className="flex justify-between gap-4">
            <Button variant="outlined" onClick={toggleDrawer}>
              Cancel
            </Button>
            <div className="flex gap-4 w-full justify-end">
              <Button variant="contained" onClick={handleAddMore} disabled={isLoading}>
                {open?.id ? "Update & Add More" : "Save & Add More"}
              </Button>
              <Button variant="contained" onClick={handleSave} disabled={isLoading}>
                {open?.id ? "Update" : "Save"}
              </Button>
            </div>
          </div>
        </div>
      )}
    </Drawer>
  );
}
